module.exports = __webpack_public_path__ + "static/media/unchecked-square.2b69f5dd.svg";